import { render, staticRenderFns } from "./banksmain.vue?vue&type=template&id=125030c2&scoped=true"
import script from "./banksmain.vue?vue&type=script&lang=js"
export * from "./banksmain.vue?vue&type=script&lang=js"
import style0 from "./banksmain.vue?vue&type=style&index=0&id=125030c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125030c2",
  null
  
)

export default component.exports